import React from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export const WA_RE = /^\+[1-9]\d{7,14}$/;
export const normalizeWa = (v) => (v || "").replace(/[\s\-()]/g, "");
const MESSAGE = "Hi Archedia, I'd like to explore properties in Bangalore.";

export const WhatsAppButton = () => {
  const { data } = useApp();
  const { pathname } = useLocation();
  const number = normalizeWa(data.settings?.whatsapp);
  if (!WA_RE.test(number) || pathname.startsWith("/nimda")) return null;
  const href = `https://wa.me/${number.replace("+", "")}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Archedia on WhatsApp"
      data-testid="whatsapp-float"
      className="group fixed bottom-5 right-5 z-[90] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-105 sm:bottom-6 sm:right-6"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7 fill-current" aria-hidden="true">
        <path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.3.7 4.6 1.9 6.5L4 29l7.8-2c1.8 1 3.9 1.5 6 1.5h.2c6.6 0 12-5.3 12-11.9S22.6 3 16 3zm0 21.8c-1.9 0-3.7-.5-5.3-1.5l-.4-.2-4.6 1.2 1.2-4.4-.3-.4a9.7 9.7 0 0 1-1.6-5.4c0-5.4 4.5-9.8 10-9.8s10 4.4 10 9.8-4.5 9.8-10 9.8zm5.5-7.3c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2l-1 1.2c-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5.3-.5c.1-.2 0-.4 0-.5l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z" />
      </svg>
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-[var(--bg-card)] px-3 py-1.5 text-xs font-medium text-[var(--text-primary)] shadow-lg opacity-0 transition-opacity group-hover:opacity-100 md:block">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
